<!-- <app-sidebar></app-sidebar> -->
<!-- Main Page Start -->
<section class="pd-tb">
    <div class="container">
        <div class="verificationWrap setPassword margin-top-2">
            <div class=" subHeader">
                <h2 class="heading2 mb-2"> Create/upload resume</h2>
                <p class="para3">Upload your detailed resume to get better job recommendations and higher visibility
                    among top recruiters.</p>
            </div>
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
                <div class="form-group">
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" id="customCheckBox1" [checked]="form.value.isAccept ==1" (change)="form.value.isAccept ==1" formControlName="isAccept">
                        <label class="custom-control-label" for="customCheckBox1">By continuing you agree to create a public resume and agree to receive job opportunities from employers</label>
                    </div>
                    <div class="text-danger" *ngIf="showError">
                        *Please agree to the above terms before adding your resume information.
                    </div>
                </div>
                <div class="btnDiv">
                    <div class="form-group">
                        <div class="input-group custom-file-button">
                            <label class="input-group-text" for="uploadbanner" *ngIf="haveFileName == null"><i><img
                                        src="assets/images/ic_upload.svg"> </i> Upload CV </label>
                            <label class="input-group-text" *ngIf="haveFileName != null">{{haveFileName}}<input
                                    type="file" class="form-control" id="uploadbanner" #myInput
                                    value="Upload Photo" accept=".pdf,.doc,.docx"></label>
                            <input type="file" class="form-control" id="uploadbanner" #myInput (change)="upload($event)" accept=".pdf,.doc,.docx">
                        </div> 
                        <p class="explain" [ngClass]="fileSize == true ? 'text-danger':''" *ngIf="fileSize"> Max file size - 5mb </p>

                    </div>

                    <div class="form-group"> 
                        <input type="submit" value="Build New Resume" class="commonBtn">
                    </div>
                </div>
                <div class="text-center">
                    <!-- <a href="javascript:void(0)" routerLink="/dashboard-job" class="mt-5 ">Skip</a> -->
                </div>

            </form>
        </div>
    </div>
</section>